exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-text-card{\r\n  color: #FFF !important;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.my-text-card option{\r\n  color: #000 !important;\r\n}\r\n\r\n.my-summary-text{\r\n  font-size: 1rem !important;\r\n}\r\n\r\n.my-card{\r\n  min-width: 200px;\r\n  max-width: 200px;\r\n  min-height: 300px;\r\n}\r\n\r\n.bg-blue{\r\n  background-color: #19B5FE;\r\n}\r\n\r\n.my-icon{\r\n  padding: 0px !important;\r\n  margin: 0px !important;\r\n  height: 1rem !important;\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.titulo1{\r\n  font-size: 1.015625rem !important;\r\n  margin-top: 0 !important;\r\n  margin-bottom: 0.5rem !important;\r\n  font-family: inherit !important;\r\n  font-weight: 500 !important;\r\n  line-height: 1.2 !important;\r\n  color: #444 !important;\r\n}\r\n\r\n.my-fix-width150{\r\n  min-width: 150px;\r\n}\r\n\r\n.my-fix-width300{\r\n  min-width: 300px;\r\n}\r\n\r\n.my-grey-title{\r\n  color :#7f8c8d;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/ordenproduccion/ordenproduccion.component.css
// module id = ../../../../../src/app/components/ordenproduccion/ordenproduccion.component.css
// module chunks = main